export default __webpack_public_path__ + "static/media/annex3.6eb85585.png";